// app/frontend/controllers/availability_controller.js
import { Controller } from "@hotwired/stimulus";
import consumer from "../channels/consumer";

export default class extends Controller {
  static targets = ["statusButton", "statusWrapper"];
  static values = {
    organizationId: String,
    currentStatus: String,
    url: String,
  };

  connect() {
    this.updateButtons(this.currentStatusValue);

    // Subscribe to the organization channel to receive status updates
    this.subscription = consumer.subscriptions.create(
      { channel: "OrganizationChannel", organization_id: this.organizationIdValue },
      {
        connected: () => {},
        disconnected: () => {},
        received: (data) => {
          if (data.type === "availability_update" && data.user_id === this.element.dataset.userId) {
            this.updateButtons(data.status);
          }
        },
      }
    );
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  changeStatus(event) {
    event.preventDefault();
    const newStatus = event.currentTarget.dataset.status;

    if (newStatus === this.currentStatusValue) {
      return; // Don't do anything if status is already the same
    }

    const csrfToken = document.querySelector("meta[name='csrf-token']").content;
    const url = this.urlValue || "/profile/availability";

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({ availability_status: newStatus }),
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Failed to update status");
      })
      .then(data => {
        this.currentStatusValue = data.status;
        this.updateButtons(data.status);
      // Optional: Show a small notification
      })
      .catch(error => {
        console.error("Error updating availability status:", error);
      // Optional: Show an error message
      });
  }

  updateButtons(newStatus) {
    this.statusButtonTargets.forEach(button => {
      if (button.dataset.status === newStatus) {
        button.classList.remove("text-gray-500", "hover:text-gray-900", "dark:text-gray-400", "dark:hover:text-white");
        button.classList.add("bg-white", "text-green-600", "shadow-sm", "dark:bg-gray-700");
      } else {
        button.classList.remove("bg-white", "text-green-600", "shadow-sm", "dark:bg-gray-700");
        button.classList.add("text-gray-500", "hover:text-gray-900", "dark:text-gray-400", "dark:hover:text-white");
      }
    });
  }
}
